import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as reducers from '../app/reducers';

import { LoadLoggedInUserInfo } from './user-entity/user-entity.actions';
import { LoggedInUserInfo } from './user-entity/logged-in-user-info.interface';
import { FailureSnackbarComponent } from './shared/failure-snackbar.component';
import { WindowRef } from './core/window.interface';
import { SuccessSnackbarComponent } from './shared/success-snackbar.component';
import { MatIconsService } from './shared/mat-icons-service';
import { GainsightService } from './core/gainsight.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  userInfo: LoggedInUserInfo;
  browserId = Date.now();
  componentMap = {
    APP_ERROR_MESSAGE: [FailureSnackbarComponent, 'mat-snack-bar-failure'],
    SETUP_WIZARD_OUS_RESYNCED: [
      SuccessSnackbarComponent,
      'mat-snack-bar-success',
    ],
    CHANGE_PASSWORD_SUCCESS: [
      SuccessSnackbarComponent,
      'mat-snack-bar-success',
    ],
    CHANGE_PASSWORD_FAILURE: [
      FailureSnackbarComponent,
      'mat-snack-bar-failure',
    ],
    APP_POLLING_FAILURE: [FailureSnackbarComponent, 'mat-snack-bar-failure'],
  };
  constructor(
    private iconsService: MatIconsService,
    private store: Store<reducers.State>,
    private winRef: WindowRef,
    private gainsightService: GainsightService
  ) {}

  ngOnInit() {
    this.iconsService.init();
    this.store.dispatch(LoadLoggedInUserInfo.init({}));
    this.store
      .select(reducers.getLoggedInUserInfo)
      .pipe(takeUntil(this.destroy$), skip(1))
      .subscribe((userInfo) => {
        this.userInfo = userInfo;

        if (this.userInfo?.isAdmin) {
          this.gainsightService.injectGainsightTag('AP-YXDLPMXWJTZM-2-3');

          // Identify user
          this.gainsightService.init({
            user: {
              id: this.userInfo.email,
              fid: this.userInfo.fid,
              email: this.userInfo.email,
            },
          });
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
